<template>

<div class="alert">

	<div class="alert-icon" :class="{'is-error': alert.type === $constants.alert.type.error, 'is-warning': alert.type === $constants.alert.type.warning, 'is-info': alert.type === $constants.alert.type.info}"></div>

	<div class="alert-text" ref="text" v-html="alert.message"></div>

	<div class="alert-inputs" v-if="alert.inputs.length">
		
		<com-input v-for="input in alert.inputs" :key="input" :input="inputs[input]" :dark="true" />

	</div>

	<div class="alert-buttons" v-if="visible(alert, 'buttons')">

		<template v-for="button in alert.buttons.items">

			<button class="alert-buttons-item" :key="button.id" v-if="visible(button)" v-on:click="onButtonClick(button)"><span>{{ button.text }}</span></button>

		</template>

	</div>

	<com-info :block="block" :info="info" :light="true" :modal="true" :auto="true" v-if="info" v-on:close="info = false" />

</div>

</template>

<script>

import comInput from './form/Input'
import comInfo from './form/Info'

export default {

	props: ['alert'],

	components: {
		'com-info': comInfo,
		'com-input': comInput
	},

	data: function() {

		return {
			block: false,
			info: false,
			links: []
		}

	},

	created: function() {

		this.$nextTick(function() {

			this.$_.each(this.$refs.text.getElementsByTagName('a'), function(link) {

				if (link.getAttribute('data-link-type') === '1' || link.getAttribute('data-link-type') === '5') {

					this.links.push(link)

				} 

				link.addEventListener('click', this.onLinkClick.bind(this))

			}.bind(this))

		}.bind(this))

	},

	beforeDestroy: function() {

		this.$_.each(this.links, function(link) {

			link.removeEventListener('click', this.onLinkClick.bind(this))

		}.bind(this))	

	},

	methods: {

		onLinkClick: function(e) {

			e.stopPropagation()
			
			if (e.srcElement.getAttribute('data-link-type').toString() === '1') {

				e.preventDefault()
				this.block = false
				this.info = parseInt(e.srcElement.getAttribute('data-link-page'))

			} else if (e.srcElement.getAttribute('data-link-type').toString() === '5') {

				e.preventDefault()
				this.block = true
				this.info = parseInt(e.srcElement.getAttribute('data-link-page'))

			}

		},

		onButtonClick: function(button) {

			if (button.variable) {

				this.$store.commit('session/values', {
					id: button.variable,
					value: parseFloat(button.value)
				})

			}

			if (button.type === this.$constants.button.type.review) {

				this.$store.dispatch('review')

			}

			if (button.type === this.$constants.button.type.exit) {

				this.$router.push({
					name: 'Home'
				})

			}

			if (button.type === this.$constants.button.type.proceed) {

				if (this.$isPatient) {

					// Patient flow (e.g. post data-entry alert) doesn't use the
					// clinician proceed action; just dismiss so the caller resumes.
					// Not marked completed, so it shows again every time.
					this.$store.commit('session/alerts/current', false)

				} else {

					this.$store.dispatch('proceed')

				}

			}

			if (button.type === this.$constants.button.type.finish) {

				this.$store.dispatch('finish')

			}

		}

	}

}

</script>

<style scoped>

.alert {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
}

.alert-icon {
	width: 112px;
	height: 112px;
	margin: 0px auto;
	margin-bottom: 32px;
	background-position: 50% 0px;
	background-repeat: no-repeat;
	background-size: 112px 112px;
}

.is-mobile .alert-icon {
	width: 64px;
	height: 64px;
	background-size: 64px 64px;
}

.alert-icon.is-error {
	background-image: url(~@/assets/alert.error.svg);
}

.alert-icon.is-warning {
	background-image: url(~@/assets/alert.warning.svg);
}

.alert-icon.is-info {
	background-image: url(~@/assets/alert.info.svg);
}

.alert-text {
	color: #343434;
	padding: 0px 90px;
}

.alert-inputs {
	padding: 0px 90px;
}

.is-mobile .alert-text {
	padding: 0px;
}

.is-dark .alert-text {
	color: #fff;
}

.alert-text >>> p:first-child {
	font-weight: 600;
	text-align: center;
}

.alert-text >>> p {
	font-size: 20px;
	line-height: 24px;
	font-weight: 300;
	text-align: left;
	margin-bottom: 32px;
}

.alert-text >>> a {
	font-weight: bold;
}

.alert-text >>> a:hover {
	text-decoration: underline;
}

.is-mobile .alert-text >>> p {
	font-size: 14px;
	line-height: 18px;
}

.alert-text >>> ul {
	margin-bottom: 32px;
	list-style: disc;
}

.alert-text >>> li {
	font-size: 20px;
	line-height: 24px;
	font-weight: 300;
	margin-left: 32px;
}

.is-mobile .alert-text >>> li {
	font-size: 14px;
	line-height: 18px;
	margin-left: 16px;
}

.alert-buttons {
	display: flex;
	flex-direction: row;
	justify-content: center;
}

.is-mobile .alert-buttons {
	flex-direction: column;
}

.alert-buttons-item {
	margin: 0px 10px;
	min-width: 150px;
	padding: 0px 20px;
	height: 48px;
	border-radius: 24px;
	border: 2px solid var(--primary-color);
	font-size: 18px;
	font-weight: 700;
	color: #343434;
	margin-left: 20px;
	transition: all 300ms ease-in-out;
}

.is-mobile .alert-buttons-item {
	width: 100%;
	margin: 0px 0px 10px 0px;
	min-height: 32px;
	line-height: 18px;
	font-size: 14px;
	padding: 0px 10px;
	border-radius: 16px;
}

.alert-buttons-item:hover {
	background-color: var(--primary-color);
	color: #fff;
}

.is-dark .alert-buttons-item {
	color: #fff;
}

.is-dark .alert-buttons-item:hover {
	background-color: var(--primary-color);
	color: #343434;
}

</style>